import { permissions } from './roles'

export const BLOCK_TYPES = {
    CLAN_MODES: 'clanModes',
    STATISTICS: 'statistics',
}

export const NEED_PERMISSIONS_FOR_MEMBER_CONTROL_BLOCK = [
    permissions.DIVIDE_PROFITS,
    permissions.CHANGE_ROLE,
    permissions.CHANGE_COMMANDER,
    permissions.REMOVE_MEMBER,
]



// WEBPACK FOOTER //
// ./utils/clan_management/constants.js